
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking-flow",
      function () {
        return require("private-next-pages/booking-flow.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booking-flow"])
      });
    }
  